import { render, staticRenderFns } from "./PrivilegesList.vue?vue&type=template&id=822930d6&scoped=true"
import script from "./PrivilegesList.vue?vue&type=script&lang=js"
export * from "./PrivilegesList.vue?vue&type=script&lang=js"
import style0 from "./PrivilegesList.vue?vue&type=style&index=0&id=822930d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822930d6",
  null
  
)

export default component.exports